export default __webpack_public_path__ + "images/resume-icon-94ec70.svg";